import React from 'react';

import _ from '../../locale';
import ChangePasswordView from './ChangePasswordView';

type Props = {
    changePassword: (password: string, new_password: string) => void;
    onNext?: () => void;
};

const ChangePassword: React.FC<Props> = ({ changePassword, onNext }) => {
    const handleSuccess = () => {
        alert(_('change_password_success_message'));

        onNext?.();
    };

    return <ChangePasswordView onSuccess={handleSuccess} changePassword={changePassword} />;
};

export default ChangePassword;
